import { useState } from "react";
import { toast } from "sonner";
import { CalendarDays, Flame, X } from "lucide-react";
import { api } from "@/lib/api";

export function WeekSummary({ w, setW }) {
  const [gone, setGone] = useState(false);
  if (!w?.show || gone) return null;
  const dismiss = async () => { setGone(true); setW({ ...w, show: false }); try { await api.post("/v2/today/week/dismiss"); } catch { toast.error("Couldn't save that. It may show again."); } };
  const pct = w.total ? Math.round((100 * w.done) / w.total) : 0;
  return (
    <section className="card p-5 bg-[#2D2926] border-[#2D2926] text-stone-100 rise" data-testid="week-summary">
      <div className="flex items-start justify-between gap-3">
        <span className="eyebrow !text-stone-300 flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" />Your week</span>
        <button onClick={dismiss} aria-label="Dismiss" data-testid="week-summary-dismiss" className="h-9 w-9 -m-2 grid place-items-center text-stone-400"><X className="h-4 w-4" /></button>
      </div>
      <p className="font-display text-3xl mt-2" data-testid="week-summary-count">{w.done} of {w.total} done</p>
      <div className="h-2 mt-3 rounded-full bg-white/15 overflow-hidden"><div className="h-full rounded-full bg-[#E9C46A]" style={{ width: `${pct}%` }} /></div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-stone-300">
        <span data-testid="week-summary-days">{w.days_active} active {w.days_active === 1 ? "day" : "days"}</span>
        {w.best_day && <span data-testid="week-summary-best">Best day: {w.best_day.label} ({w.best_day.done})</span>}
        {w.streak > 0 && <span className="inline-flex items-center gap-1" data-testid="week-summary-streak"><Flame className="h-3.5 w-3.5 text-[#E9C46A]" />{w.streak}-week streak</span>}
      </div>
      {w.goals.length > 0 && <ul className="mt-4 space-y-1.5 text-sm" data-testid="week-summary-goals">
        {w.goals.map((g) => <li key={g.id} className="flex justify-between gap-3"><span className="truncate">{g.title}</span><span className="font-mono text-xs text-stone-300 shrink-0">{g.progress}/{g.target}</span></li>)}
      </ul>}
      <p className="text-sm text-stone-100 mt-4 italic" data-testid="week-summary-line">{w.line}</p>
    </section>
  );
}
